/**
 * EIGENE BILD-MASKE IM EIGENEN FORMAT (Jan 24.10.2026: „Muss die Maske
 * quadratisch sein? Ein Bild im Querformat als Maske wird verzerrt.“).
 *
 * Die Maske wird in eine Fläche gezeichnet, die über das ganze Bild gespannt
 * ist. Bisher füllte sie diese Fläche immer ganz — eine Querformat-Maske auf
 * einem quadratischen Bild wurde dadurch gestaucht. Jetzt behält sie ihr
 * Seitenverhältnis und passt bei Größe 1 ganz ins Bild („contain“).
 *
 * Liefert Breite und Höhe der Maske als Anteil der Bildbreite bzw. -höhe.
 */
export function maskenRechteck(
  maskenSeitenverhaeltnis: number,
  bildSeitenverhaeltnis: number,
  groesse: number,
): { breite: number; hoehe: number } {
  const m = maskenSeitenverhaeltnis > 0 ? maskenSeitenverhaeltnis : 1
  const b = bildSeitenverhaeltnis > 0 ? bildSeitenverhaeltnis : 1
  // breiter als das Bild: volle Breite, Höhe nach Maske; sonst umgekehrt
  return m >= b
    ? { breite: groesse, hoehe: (groesse * b) / m }
    : { breite: (groesse * m) / b, hoehe: groesse }
}
